import React from "react"
import { SvgCheck, SvgPayment } from "../icons"

export type CheckoutStep = "coach" | "program" | "checkout"

interface Step {
  key: CheckoutStep
  label: string
}

const STEPS: Step[] = [
  { key: "coach", label: "Select coach" },
  { key: "program", label: "Select program" },
  { key: "checkout", label: "Checkout" },
]

interface CheckoutStepperProps {
  currentStep: CheckoutStep
}

const CheckoutStepper: React.FC<CheckoutStepperProps> = ({ currentStep }) => {
  const currentIndex = STEPS.findIndex((s) => s.key === currentStep)

  return (
    <div className="mb-4 flex items-center">
      {STEPS.map((step, index) => {
        const isCompleted = index < currentIndex
        const isActive = index === currentIndex

        return (
          <React.Fragment key={step.key}>
            <div className="flex flex-col items-center">
              <div
                className={[
                  "flex h-[60px] w-[60px] items-center justify-center rounded-full border",
                  isActive
                    ? "border-blurple text-blurple"
                    : "border-grayMist text-blurple",
                ].join(" ")}
              >
                {isCompleted ? (
                  <SvgCheck className="h-4 w-4" />
                ) : step.key === "checkout" || isActive ? (
                  <SvgPayment />
                ) : (
                  <SvgCheck className="h-4 w-4 opacity-0" />
                )}
              </div>
              <p className="min-w-fit text-base mt-2">{step.label}</p>
            </div>

            {index < STEPS.length - 1 && (
              <div className="border-grayCloud mx-[24px] mb-[32px] h-[2px] w-full border-b border-dashed" />
            )}
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default CheckoutStepper
